module.exports = __webpack_public_path__ + "logo_color.644e6815dab38127de258510411cbe12.png";